import util from "./_util";

const { request } = util;

export default {
  masterLogin(data) {
    return request.post("/SysAdmin/LoginAdmin", data);
  },
};
